module.exports = __webpack_public_path__ + "static/media/closed-captioning.6b35797f.svg";